import React from "react"
import PropTypes from "prop-types"
import { SettingsBlockContent } from "@modules/site/settings"
import Loading from "@modules/ui/components/Loading"
import { ManualWebhookIntegrations } from "./ManualWebhookIntegrations"
import { CmsManualIntegrationRow } from "./CmsManualIntegrationRow"

function ManualIntegrationContent({ loading, error, cmsIntegrations, siteId }) {
  if (loading) {
    return (
      <Loading
        data-testid="manual-integration-loading"
        delay={1000}
        message="loading available cms integrations..."
        bufferSize="none"
      />
    )
  }

  if (error) {
    return <p data-testid="manual-integration-error">{error.message}</p>
  }

  if (cmsIntegrations.length === 0) {
    return (
      <p data-testid="manual-integration-no-integrations">No integrations</p>
    )
  }

  return (
    <div data-testid="manual-integrations">
      {cmsIntegrations.map(cms => {
        return <CmsManualIntegrationRow key={cms.name} {...cms} />
      })}

      <ManualWebhookIntegrations siteId={siteId} />
    </div>
  )
}

export function CmsManualIntegration({
  loading,
  error,
  cmsIntegrations = [],
  siteId,
  orgSiteName,
  permissionToEdit = true,
}) {
  return (
    <SettingsBlockContent>
      <ManualIntegrationContent
        loading={loading}
        error={error}
        cmsIntegrations={cmsIntegrations}
        siteId={siteId}
        orgSiteName={orgSiteName}
        permissionToEdit={permissionToEdit}
      />
    </SettingsBlockContent>
  )
}

CmsManualIntegration.propTypes = {
  siteId: PropTypes.string,
  cmsIntegrations: PropTypes.array,
  error: PropTypes.bool,
  loading: PropTypes.bool,
  docUrl: PropTypes.string,
  orgSiteName: PropTypes.string,
  permissionToEdit: PropTypes.bool,
}
